import React from 'react';

import { Modal, Button, Form, Input, Slider } from 'antd';
import { useTranslation } from 'react-i18next';

const formLayout = {
	labelCol: { span: 24 },
	wrapperCol: {
		span: 24,
	},
};

export const CommentEditionModal = (props: any) => {
	const [form] = Form.useForm();
	const { t } = useTranslation();

	const handleFormSubmit = () => {
		console.log('handleFormSubmit');
		form.validateFields()
			.then((values) => {
				console.log('validated', values);
				props.onSave(values);
				props.onHide();
			})
			.catch((errorInfo) => {
				console.log('error', errorInfo);
			});
	};

	const footer = (
		<div style={{ display: 'flex' }}>
			<Button
				onClick={() => {
					props.onDelete(props);
				}}
				danger={true}
				style={{ marginRight: 'auto' }}
			>
				Delete
			</Button>
			<Button
				onClick={() => {
					props.onHide();
				}}
			>
				Cancel
			</Button>
			<Button onClick={handleFormSubmit} type="primary" className="ml-1">
				Save
			</Button>
		</div>
	);

	return (
		<Modal
			visible={true}
			title={props.option?.name}
			okButtonProps={{ style: { display: 'none' } }}
			onCancel={props.onHide}
			cancelText="Close"
			footer={footer}
			width={"calc( min(100%, 800px) )"}
		>
			<Form
				{...formLayout}
				form={form}
				onFinish={(values) => {
					props.onChange(props.id, values);
					props.onHide();
				}}
				initialValues={props.values}
			>
				<b>{t(`models.${props.item?.__typename.toLowerCase()}.name`)} :</b>
				{" "}{props.item?.name}
				<Form.Item name="description" label={t('models.optionEvaluation.fields.description_explanation')}>
					<Input.TextArea rows={6}></Input.TextArea>
				</Form.Item>
			</Form>
		</Modal>
	);
};

export default CommentEditionModal;
